import { nextTick, ref } from 'vue';

import type { useUserStore } from '@/stores/user';

type UserStore = ReturnType<typeof useUserStore>;

export function useHelperSignupProfile(params: {
  formData: {
    phoneNumber: string;
    profilePicture: File | null;
  };
  v$: any;
  userStore: UserStore;
}) {
  const saved = ref(false);
  const phoneNumberSaved = ref(params.formData.phoneNumber);

  const markSaved = () => {
    saved.value = true;
    setTimeout(() => {
      saved.value = false;
    }, 1500);
  };

  const changePhoneNumber = async () => {
    await nextTick();

    params.v$.value.phoneNumber.$touch();

    const isValid = await params.v$.value.phoneNumber.$validate();
    const hasChanged = params.formData.phoneNumber !== phoneNumberSaved.value;

    if (!isValid || !hasChanged) {
      return;
    }

    try {
      await params.userStore.updateUser({
        phoneNumber: params.formData.phoneNumber,
      });

      phoneNumberSaved.value = params.formData.phoneNumber;
      markSaved();
    } catch (error) {
      console.log(error);
    }
  };

  const uploadProfilePicture = async (profilePicture: File) => {
    await nextTick();

    const isValid = await params.v$.value.profilePicture.$validate();
    if (!isValid) {
      return;
    }

    try {
      await params.userStore.uploadPicture({
        profilePicture,
      });

      markSaved();
    } catch (error) {
      console.log(error);
    }
  };

  return {
    saved,
    changePhoneNumber,
    uploadProfilePicture,
    markSaved,
  };
}
